import { render, staticRenderFns } from "./Switches.vue?vue&type=template&id=a22ebf3c"
import script from "./Switches.vue?vue&type=script&lang=js"
export * from "./Switches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports